import { Flex, Table, useDisclosure } from '@chakra-ui/react';
import { isValidElement, ReactNode } from 'react';
import { addSpacesToCamelCase } from '../../util/formatters/camelCaseFormater';
import { BaseButton, BaseDialog } from '@cks-internal/react-base';

type DynamicTableRowWithHeaderProps<T, K extends keyof T> = {
  obj: T;
  property: K;
  header?: string;
  render?(d: T[K]): ReactNode[] | ReactNode;
  toLargeButton?: boolean;
};
export default function DynamicTableRowWithHeader<T, K extends keyof T>({
  toLargeButton,
  header,
  obj,
  property: key,
  render
}: DynamicTableRowWithHeaderProps<T, K>) {
  const toLargeDisclosure = useDisclosure();
  const width = '20%';
  header = header ?? addSpacesToCamelCase(key.toString());
  if (!obj[key]) {
    return <></>;
  }
  const rendered = typeof render == 'function' ? render?.(obj[key]) : obj[key]?.toString?.();
  if (!rendered) {
    return <></>;
  }

  if (typeof rendered != 'string' && typeof rendered != 'number' && !isValidElement(rendered)) {
    return <></>;
  }

  if (typeof rendered == 'string' && !toLargeButton) {
    if (rendered.length > 300) {
      toLargeButton = true;
    }
  }

  return (
    <Table.Row>
      <Table.Cell verticalAlign={'top'} textAlign={'left'} width={width}>
        <b>{header}</b>
      </Table.Cell>
      <Table.Cell
        onClick={() => {
          toLargeButton && toLargeDisclosure.onOpen();
        }}
        cursor={toLargeButton ? 'grab' : 'initial'}>
        {toLargeButton ? (
          <Flex justifyContent={'center'}>
            <BaseButton size={'sm'} textAlign={'center'}>
              Display as Popup
            </BaseButton>
          </Flex>
        ) : (
          rendered
        )}
      </Table.Cell>
      {toLargeDisclosure && (
        <BaseDialog dragDialog={{}} header={header} disclosure={toLargeDisclosure}>
          {<>{rendered}</>}
        </BaseDialog>
      )}
    </Table.Row>
  );
}
